import request from "@utils/request";

/**
 * 获取兑换劵订单统计数据 （累计 待兑换 已兑换 ）
 */
export function getCouponsCount() {
  return request.get("/coupons_count");
}

/**
 * 获取兑换劵订单
 */
export function getCouponsOrderLest(data) {
    return request.get("/getCouponsOrderLest",data);
}

/**
 * 根据订单号 获取订单可以领取的优惠券列表
 */
export function getOrderToExchangeLest(data) {
    return request.get("/getOrderToExchangeLest",data);
}

/**
 * 统计卡包统计信息
 */
export function getCardbagCount(data) {
    return request.get("/getCardbagCount",data);
}

/**
 * 我的卡包列表
 */
export function getCardbagLest(data) {
    return request.get("/getCardbagLest",data);
}

/**
 * 获取劵详情
 */
export function getCardbagDetails(data) {
    return request.get("/getCardbagDetails",data);
}

/**
 * 商品卷领取
 */
export function lingqu(data) {
    return request.get("/lingqu",data);
}







//
// /**
//  * 拼团 取消开团
//  */
// export function getCombinationRemove(data) {
//   return request.post("/combination/remove", data);
// }